import axios from '../axios';

export default {
  getConfig() {
    return axios.get('/ratelookup/config');
  },
  getStats() {
    return axios.get('/ratelookup/stats');
  },
  createRequest(payload) {
    return axios.post('/ratelookup/request', payload);
  },
  uploadRequest(formData) {
    return axios.post('/ratelookup/upload', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
  listRequests(params) {
    return axios.get('/ratelookup/requests', { params });
  },
  getRequestDetail(requestId, params) {
    return axios.get(`/ratelookup/request/${requestId}`, { params });
  },
  getRequestHeader(requestId) {
    return axios.get(`/ratelookup/request/${requestId}/header`);
  },
  getRequestResults(requestId, params) {
    return axios.get(`/ratelookup/request/${requestId}/results`, { params });
  },
  getRequestFilterOptions(requestId) {
    return axios.get(`/ratelookup/request/${requestId}/filter-options`);
  },
  searchLanes(requestId, params) {
    return axios.get(`/ratelookup/request/${requestId}/search-lanes`, { params });
  },
  getRequestFailedTasks(requestId, params) {
    return axios.get(`/ratelookup/request/${requestId}/failed-tasks`, { params });
  },
  getInvalidEntries(requestId, params) {
    return axios.get(`/ratelookup/request/${requestId}/invalid-entries`, { params });
  },
  getInvalidDownloadUrl(requestId) {
    return axios.get(`/ratelookup/request/${requestId}/invalid-download`);
  },
  downloadInputFile(requestId) {
    return axios.get(`/ratelookup/request/${requestId}/input-download`);
  },
  exportRequest(requestId) {
    return axios.get(`/ratelookup/request/${requestId}/export`);
  },
  deleteRequest(requestId) {
    return axios.delete(`/ratelookup/request/${requestId}`);
  },
  downloadTemplate() {
    return axios.get('/ratelookup/template', { responseType: 'blob' });
  },
  createFilteredExport(requestId, filters) {
    return axios.post(`/ratelookup/request/${requestId}/filtered-export`, filters);
  },
  getFilteredReports(requestId, params) {
    return axios.get(`/ratelookup/request/${requestId}/filtered-reports`, { params });
  },
  downloadFilteredReport(requestId, reportId) {
    return axios.get(`/ratelookup/request/${requestId}/filtered-reports/${reportId}/download`);
  },
};
